import * as React from 'react';
const SvgPlayVideo = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <path
         fill={props.fill ? props.fill : '#4A4A4A'}
         fillRule="nonzero"
         d="M12.838 22.152c0-8.627 6.488-12.371 13.968-8.06l3.888 2.243a1.296 1.296 0 0 1-1.296 2.245l-3.886-2.243c-5.753-3.316-10.083-.817-10.083 5.815v12.287c0 6.63 4.328 9.13 10.066 5.814l5.339-3.072 5.338-3.071c5.752-3.315 5.752-8.314 0-11.63a1.296 1.296 0 0 1 1.294-2.245c7.482 4.312 7.482 11.808-.001 16.12l-5.339 3.072-5.336 3.071c-7.465 4.313-13.952.565-13.952-8.06z"
      />
   </svg>
);
export default SvgPlayVideo;
